import { FaqResponse } from 'src/admin-entity/interface/faq/faq.interface';

export interface FaqInitType {
    items: FaqResponse[];
}

export const initialState: FaqInitType = {
    items: [],
};
